import { toast } from "sonner";
import { fmtDay } from "@/lib/utils";

const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

const label = (o) => `
  <div class="label">
    <div class="top"><img src="${window.location.origin}/baron-logo.jpg" alt=""/><span class="base">${esc(o.base_kitchen)}</span></div>
    <div class="caf">${esc((o.cafeteria_name || "").trim())}</div>
    <div class="when">${esc(o.delivery_date ? fmtDay(o.delivery_date) : "")} · ${esc(o.delivery_time)}${o.delivery_exact_time ? ` · ${esc(o.delivery_exact_time)}` : ""}</div>
    <table>${o.items.map((it) => `<tr><td>${esc(it.item_name)}</td><td class="q">${it.qty} ${esc(it.unit)}</td></tr>`).join("")}</table>
    ${o.remarks ? `<div class="rem">Note: ${esc(o.remarks)}</div>` : ""}
    <div class="foot"><span>Packed by: ________</span><span>#${esc(o.id.slice(0, 6).toUpperCase())}</span></div>
  </div>`;

export const printPackingLabels = (orders) => {
  if (!orders.length) return toast.error("No orders to label");
  const w = window.open("", "_blank");
  if (!w) return toast.error("Allow pop-ups to print labels");
  w.document.write(`<!doctype html><html><head><title>Packing Labels</title><style>
    @page{size:A4;margin:8mm}
    body{font-family:Arial,sans-serif;margin:0;color:#111}
    .sheet{display:grid;grid-template-columns:1fr 1fr;gap:6mm}
    .label{border:2px dashed #555;border-radius:6px;padding:4mm;break-inside:avoid;font-size:12px}
    .top{display:flex;justify-content:space-between;align-items:center}
    .top img{height:22px}.base{font-weight:bold;border:1px solid #111;padding:1px 6px;border-radius:4px;font-size:11px}
    .caf{font-size:18px;font-weight:bold;margin:4px 0 2px}.when{font-weight:bold;color:#c2410c;margin-bottom:4px}
    table{width:100%;border-collapse:collapse}td{border-bottom:1px dotted #999;padding:2px 0}.q{text-align:right;font-weight:bold;white-space:nowrap}
    .rem{font-style:italic;margin-top:4px}.foot{display:flex;justify-content:space-between;margin-top:6px;font-size:11px;color:#444}
  </style></head><body><div class="sheet">${orders.map(label).join("")}</div>
  <script>window.onload=function(){setTimeout(function(){window.print()},300)}</script></body></html>`);
  w.document.close();
};
